
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AccountingDocumentStatusEnum } from '@gid/models';
import Api from '@gid/vue-common/api';
import PaymentAmount from '../../accounting/PaymentAmount.vue';

function isHiddenDocument(doc: {
  status?: string;
  cancellationStatus?: string | null;
}): boolean {
  if (doc.status === AccountingDocumentStatusEnum.WRITTEN_OFF) return true;
  if (doc.cancellationStatus) return true;
  return false;
}

interface PaymentRow {
  key: string;
  payment: any;
  accountName: string;
  docNumber: string;
  docPath: string | null;
}

@Component({
  components: { PaymentAmount },
})
export default class JobPayments extends Vue {
  // Job PK: the entity's `id` property maps to the `sfid` column, so the
  // documents endpoint's `jobs.id` filter expects the sfid value.
  @Prop({ required: true }) jobSfid!: string;

  show = false;
  loading = true;
  rows: PaymentRow[] = [];

  created() {
    this.fetchPayments();
  }

  async fetchPayments() {
    this.loading = true;
    try {
      const response = await Api.get('/documents-api/accounting/documents', {
        params: {
          s: JSON.stringify({ 'jobs.id': this.jobSfid }),
          limit: 100,
        },
        autoCancelScope: 'job-payments',
      });
      const payload = response.data;
      const docs = Array.isArray(payload) ? payload : payload?.data ?? [];

      const rows: PaymentRow[] = [];
      for (const doc of docs) {
        if (isHiddenDocument(doc)) {
          continue;
        }
        for (const payment of doc.payments || []) {
          rows.push({
            key: `${doc.id}-${payment.id}`,
            payment,
            accountName: doc.target?.name ?? '',
            docNumber: doc.number,
            docPath: doc.path ?? null,
          });
        }
      }
      this.rows = rows;
    } finally {
      this.loading = false;
    }
  }
}
